import { render } from "./UploadModal.vue?vue&type=template&id=6e8df53a&scoped=true&bindings={}"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"

import "./UploadModal.vue?vue&type=style&index=0&id=6e8df53a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e8df53a"

export default script